module.exports = __webpack_public_path__ + "static/media/butterflywings.74cfaf07.webp";